<script setup lang="ts">
import type { NovaButtonSimpleTextProps } from './NovaButtonSimpleText.types'

withDefaults(defineProps<NovaButtonSimpleTextProps>(), {
  labelSize: 11,
  labelStyle: () => ({}),
  icon: null,
  disabled: false,
})
</script>

<template>
  <button type="button" class="btn-simple" :disabled="disabled">
    <span class="label" :style="labelStyle">
      {{ label }}
    </span>
    <NovaIcon v-if="icon" :icon="icon" :size="16" class="icon" />
    <slot name="extra" />
  </button>
</template>

<style lang="scss" scoped>
.btn-simple {
  display: inline-flex;
  align-items: center;

  > .label {
    @include text-style($text-body-11-regular);
    color: $color-text-3;
  }

  > .icon {
    color: $color-text-3;
  }
}
</style>
